export const options = {
    serverHost: 'http://60.213.50.226:8185'
}

export default {
    install(Vue, options) {
        Vue.prototype.$options = {
            ...options
        }
    },
    options
}


// WEBPACK FOOTER //
// ./utils/options.js